const LABELS = {
  REFERRALS: 'Referrals',
  SUBMIT: 'Submit',
  CONFIRM_DETAILS:
    'Confirm the referrals you are submitting below and use the back button if anything needs to be changed',
};

export default LABELS;
